module.exports = __webpack_public_path__ + "img/welcome_9.f38fbbb7.jpg";